import { CARD_WIDTH } from 'common/builder/components/chart/FlowChart/components/Block/generic/Cards/lib/constants'
import {
  Colors,
  CONTENT_BLOCK_SHADOW,
} from 'common/builder/components/chart/FlowChart/nodes/shared/styles'

export const Card = {
  display: 'flex',
  flexDirection: 'column',
  width: `${CARD_WIDTH}px`,
  padding: 0,
  borderRadius: '20px',
  background: Colors.BLOCK_DEFAULT,
} as const

export const CardWithShadow = {
  ...Card,
  boxShadow: CONTENT_BLOCK_SHADOW,
}

export const CardHidden = {
  opacity: 0.2,
}

export const Content = {
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  padding: `16px 20px`,
} as const

export const UrlICon = {
  position: 'absolute',
  display: 'flex',
  top: '16px',
  right: '16px',
} as const

export const Title = {
  fontSize: '24px',
}

export const Subtitle = {
  color: Colors.SECONDARY,
}
